/**
 * Extracts the transfer QR quantity options from the
 * `GET /api/qrs/transfer-qty-options` response body.
 * @param {unknown} body Response body, e.g. `{ data: { options: [50, 100] } }`.
 * @returns {number[]} Positive integer options.
 */
export function parseTransferQtyOptions(body) {
  const options = body && body.data ? body.data.options : undefined;
  if (!Array.isArray(options)) {
    throw new Error("Format respons opsi jumlah transfer QR tidak valid");
  }
  return options
    .map(Number)
    .filter((value) => Number.isInteger(value) && value > 0);
}

/**
 * Fetches the transfer QR quantity options configured by the Main Dealer.
 * @param {import("axios").AxiosInstance} http Configured axios instance.
 * @returns {Promise<number[]>}
 */
export async function fetchTransferQtyOptions(http) {
  const resp = await http.get("/api/qrs/transfer-qty-options");
  return parseTransferQtyOptions(resp.data);
}
